<template>
  <div>
    <page-header :title="$t('bill.resource_tag')" />
    <page-body>
      <list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'ResourceTagIndex',
  components: {
    List,
  },
  data () {
    return {
      listId: 'ResourceTagList',
    }
  },
}
</script>
